import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRACKING_SOURCE } from "./constants";
import { getTrackingSchemaVersion } from "./config";
import { initVisitorCountry, getCachedVisitorCountry } from "./visitorCountry";

const TrackingContext = createContext(null);

export const TrackingProvider = ({ children }) => {
  const [visitorCountry, setVisitorCountry] = useState(() => getCachedVisitorCountry());

  useEffect(() => {
    let isMounted = true;

    initVisitorCountry()
      .then((result) => {
        if (!isMounted) return;
        setVisitorCountry(result ?? getCachedVisitorCountry());
      })
      .catch(() => {
        if (!isMounted) return;
        setVisitorCountry(getCachedVisitorCountry());
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      schemaVersion: getTrackingSchemaVersion(),
      trackingSource: TRACKING_SOURCE,
      visitorCountry,
    }),
    [visitorCountry]
  );

  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
};

export const useTrackingRuntime = () => {
  const context = useContext(TrackingContext);

  return (
    context || {
      schemaVersion: getTrackingSchemaVersion(),
      trackingSource: TRACKING_SOURCE,
      visitorCountry: getCachedVisitorCountry(),
    }
  );
};
